import http, { apiV2 } from "axiosSetup";
import { BaseCustomExercise, CustomExercise } from "types/custom-exercise";
import weightMetric from "config/metrics/weight";
import logEvent from "utils/logEvent";
import repCountMetric from "config/metrics/repCount";

class CustomExerciseService {
  static async getById(id: string) {
    const result = await http.get<CustomExercise>(`/custom-exercises/${id}`).then((response) => response.data);

    logEvent("CUSTOM_EXERCISE_V2_REVIEW");

    return result;
  }

  static async create(exercise: Omit<BaseCustomExercise, "isWeighted" | "isRepBased">) {
    const result = await apiV2.post<{ id: string }>(`/custom-exercises`, exercise).then((response) => response.data);
    logEvent("CUSTOM_EXERCISE_V2_CREATE", {
      derivedFromExerciseId: exercise.derivedFromExerciseId || undefined,
      isSensorExercise: `${Boolean(exercise.derivedFromExerciseId)}`,
      isRepBased: `${Boolean(exercise.metrics?.some((metric) => metric.field === repCountMetric.field))}`,
      isWeighted: `${Boolean(exercise.metrics?.some((metric) => metric.field === weightMetric.field))}`,
      isBilateral: `${Boolean(exercise.variants?.length === 0)}`,
    });

    return CustomExerciseService.getById(result.id);
  }

  static async update(id: string, exercise: Omit<BaseCustomExercise, "isWeighted" | "isRepBased" | "metrics">) {
    const result = await apiV2
      .put<{ id: string }>(`/custom-exercises/${id}`, exercise)
      .then((response) => response.data);

    return CustomExerciseService.getById(result.id);
  }

  static async delete(id: string) {
    const result = await http.delete<{ id: string }>(`/custom-exercises/${id}`).then((response) => ({ id }));

    logEvent("CUSTOM_EXERCISE_V2_DELETE");

    return result;
  }
}

export default CustomExerciseService;
